module.exports = "<p>\n  contact works!\n</p>\n"